import React from 'react';

const FeedbackMessage = (props) => {
  const {
    successMessage, successColorMessage, errorMessage, errorColorMessage,
  } = props;

  return (
    <React.Fragment>
      {successMessage && (
        <p style={{ color: `${successColorMessage}`, margin: '25px 0 0 0' }}>{successMessage}</p>
      )}
      {errorMessage && (
        <p style={{ color: `${errorColorMessage}`, margin: '25px 0 0 0' }}>{errorMessage}</p>
      )}
    </React.Fragment>
  );
};

export default FeedbackMessage;
